import { ErrorPanelType } from "../lib/ErrorPanel.types";
import { titleCaseWord } from "./titleCaseWord";

export function getColorSchemeImg(
  errorType: ErrorPanelType,
  imgColorScheme: string
): string {
  switch (errorType) {
    case ErrorPanelType.GenericError:
      return `${errorType}${titleCaseWord(imgColorScheme)}`;
    default:
      return errorType;
  }
}
